import React from 'react'
import Page from '../components/Page'
import { Button, Card, CardBody, CardHeader, Col, Label, Row, Table, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, TabContent, TabPane, Form, FormFeedback, FormGroup, FormText, Input } from 'reactstrap'
// import axios from 'axios';
import axios from '../utils/posAxios'
import StorageService from '../services/StorageService'
import { MdCameraAlt, MdFace, MdDone, MdClear, MdCreate } from 'react-icons/md'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Redirect } from 'react-router'
import PosCategoryForm from './PosCategoryForm'
import { BsPlusSquareFill } from 'react-icons/bs'
import { IconContext } from 'react-icons/lib'

class PosCategoryTable extends React.Component {
  _isMounted = true
  constructor(props) {
    super(props)
    this.state = {
      modal: false,
      conformModal: false,
      isLoading: true,
      categoryList: this.props.data.categoryList,
      storeList: this.props.data.storeList,
      selectedId: '',
      selectedData: '',
      redirect: false,
    }
  }
  static getDerivedStateFromProps(props, state) {
    if (props.data.categoryList !== state.categoryList || props.data.storeList !== state.storeList) {
      return {
        categoryList: props.data.categoryList,
        storeList: props.data.storeList,
      }
    }
    return null
  }

  toggle = (action, id) => () => {
    return this.setState({
      modal: !this.state.modal,
      isEdit: id != undefined || (id != null && action == 'EDIT') ? true : false,
      selectedId: id != undefined || (id != null && action == 'EDIT') ? id : '',
    })
  }

  toggleConfirmModal = (name, id) => () => {
    return this.setState({
      confirmModal: !this.state.confirmModal,
      selectedData: name,
      selectedId: id,
    })
  }

  closeModal = (title, message, level, reload) => {
    this.notificationSystem.addNotification({
      title: title,
      message: message,
      level: level,
      position: 'br',
      autoDismiss: 2,
      dismissible: 'click',
    })

    this.setState({
      modal: false,
    })

    if (reload) {
      window.location.reload()
    } else {
      this.props.getCategoryList()
    }
  }

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    })
  }

  getCategoryList = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    }

    axios
      .post(url + ':3002/v1/product/category', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          this.setState({
            isLoading: false,
            categoryList: result.data,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  delete = () => {
    const user = StorageService.getSession('user_info')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      category_id: this.state.selectedId,
      delete_by: user.email,
    }

    axios
      .post(url + ':3002/v1/product/category/delete', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          })
          return
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Category deleted successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.setState({ confirmModal: false })
        this.props.getCategoryList()
      })
      .catch(error => {
        alert(error)
      })
  }

  category_disable = (id, disabled) => () => {
    const user = StorageService.getSession('user_info')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      category_id: id,
      disabled: disabled == 1 ? 0 : 1,
      update_by: user.email,
    }

    axios
      .post(url + ':3002/v1/product/category/disabled', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          })
          return
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Category updated successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })

        this.props.getCategoryList()
      })
      .catch(error => {
        alert(error)
      })
  }

  componentDidMount() {
    //this.getCategoryList();
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/" />
    }

    return (
      <>
        <NotificationSystem dismissible={false} ref={notificationSystem => (this.notificationSystem = notificationSystem)} style={NOTIFICATION_SYSTEM_STYLE} />
        <div className="text-right mb-4">
          <div className="ps-btn-group">
            <Button color="link" onClick={this.toggle('ADD', null)}>
              <IconContext.Provider value={{ color: '#2a2c6b' }}>
                <BsPlusSquareFill size={25} />
              </IconContext.Provider>
            </Button>
          </div>
        </div>
        <Table responsive hover className="ps-table tb-col-3">
          <thead>
            <tr>
              <th>Name</th>
              <th>Store</th>
              <th>Disabled</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {this.state.categoryList.length < 1 && (
              <tr>
                <td colSpan="3">
                  <div className="ps-empty-data">
                    <div className="empty-content">
                      <MdCreate />
                      <h4>No data to show</h4>
                      <span>Click the 'Create' button to add new category</span>
                    </div>
                  </div>
                </td>
              </tr>
            )}

            {this.state.categoryList &&
              this.state.categoryList.length > 0 &&
              this.state.categoryList.map(item => {
                return (
                  <tr key={item.id}>
                    <td>{item.name}</td>
                    <td>{item.storename}</td>
                    <td>
                      <span className={'ps-indicator ' + (item.disabled == '1' ? 'on' : 'off')}>{item.disabled == '1' ? 'Yes' : 'No'}</span>
                    </td>
                    <td>
                      <div className="ps-action-button">
                        <Button className="theme-button theme-button-secondary" onClick={this.toggle('EDIT', item.id)}>
                          Edit
                        </Button>
                        <Button className="theme-button theme-button-primary-light" onClick={this.toggleConfirmModal(item.name, item.id)}>
                          Delete
                        </Button>
                        <Button className="theme-button theme-button-primary" onClick={this.category_disable(item.id, item.disabled)}>
                          {item.disabled == 0 ? 'Disable' : 'Enable'}
                        </Button>
                      </div>
                    </td>
                  </tr>
                )
              })}
          </tbody>
        </Table>
        <Modal isOpen={this.state.modal} toggle={this.toggle()} className={this.props.className} centered>
          <PosCategoryForm history={this.props.history} onToggleModal={this.toggle} closeModal={this.closeModal} match={this.props.match} data={this.state} getCategoryList={this.props.getCategoryList} />
        </Modal>
        <Modal isOpen={this.state.confirmModal} toggle={this.toggleConfirmModal()} className={this.props.className} centered style={{ fontSize: '0.85rem' }}>
          <ModalHeader toggle={this.toggleConfirmModal()}>Delete Category</ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12}>
                <p>Are you sure you want to delete {this.state.selectedData} ?</p>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button className="theme-button theme-button-secondary" onClick={this.toggleConfirmModal()}>
              No
            </Button>
            <Button className="theme-button theme-button-primary" onClick={() => this.delete()}>
              Yes
            </Button>
          </ModalFooter>
        </Modal>
      </>
    )
  }
}
export default PosCategoryTable
